export const apiUrl = "https://app-api-pod-qas.azurewebsites.net/api";
export const appVersion = "2.0";
